import { render, staticRenderFns } from "./wxModal.vue?vue&type=template&id=5423bed2&scoped=true&"
import script from "./wxModal.vue?vue&type=script&lang=ts&"
export * from "./wxModal.vue?vue&type=script&lang=ts&"
import style0 from "./wxModal.vue?vue&type=style&index=0&id=5423bed2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423bed2",
  null
  
)

export default component.exports